<template>
	<div>
		<vs-input
			v-validate="'required|email|min:3'"
			data-vv-validate-on="blur"
			name="email"
			icon-no-border
			icon="icon icon-user"
			icon-pack="feather"
			label-placeholder="Email"
			v-model="email"
			class="w-full"
		/>
		<span class="text-danger text-sm">{{ errors.first("email") }}</span>

		<vs-input
			data-vv-validate-on="blur"
			v-validate="'required|min:6|max:10'"
			type="password"
			name="password"
			icon-no-border
			icon="icon icon-lock"
			icon-pack="feather"
			label-placeholder="Password"
			v-model="password"
			class="w-full mt-6"
		/>
		<span class="text-danger text-sm">{{ errors.first("password") }}</span>

		<div class="flex flex-wrap justify-between my-5">
			<vs-checkbox v-model="checkbox_remember_me" class="mb-3"
				>Remember Me</vs-checkbox
			>
			<router-link to="/pages/forgot-password"
				>Forgot Password?</router-link
			>
		</div>
		<vs-button class="float-right" :disabled="!validateForm" @click="login"
			>Login</vs-button
		>
	</div>
</template>

<script>
export default {
	data() {
		return {
			email: "demo@demo.com",
			password: "demodemo",
			checkbox_remember_me: false
		};
	},
	computed: {
		validateForm() {
			return (
				!this.errors.any() && this.email != "" && this.password != ""
			);
		}
	},
	methods: {
		checkLogin() {
			// If user is already logged in notify
			if (this.$store.state.auth.isUserLoggedIn()) {
				// Close animation if passed as payload
				// this.$vs.loading.close()

				this.$vs.notify({
					title: "Login Attempt",
					text: "You are already logged in!",
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning"
				});

				return false;
			}
			return true;
		},
		login() {
			// Loading
			this.$vs.loading();

			const payload = {
				checkbox_remember_me: this.checkbox_remember_me,
				userDetails: {
					email: this.email,
					password: this.password
				},
				notify: this.$vs.notify,
				closeAnimation: this.$vs.loading.close
			};
			this.$store.dispatch("auth/loginAttempt", payload);
		}
	}
};
</script>

<style lang="scss"></style>
